import { FC } from "react";
import { AbsoluteFill, useCurrentFrame, Img, useVideoConfig } from "remotion";
import { ImageClipSchema } from "./schemas";
import z from "zod";

interface ImageZoomPanProps {
  clip: z.infer<typeof ImageClipSchema>;
}

export const ImageZoomPan: FC<ImageZoomPanProps> = ({ clip }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Calculate current time in seconds and apply scale factor
  const currentTimeInSeconds = frame / fps;
  const scaleIncreasePerSecond = 0.03;
  const scale = 1 + currentTimeInSeconds * scaleIncreasePerSecond;

  return (
    <AbsoluteFill>
      <Img
        src={clip.path}
        style={{
          transform: `scale(${scale})`,
          ...clip.style,
        }}
      />
    </AbsoluteFill>
  );
};
